<template lang="pug">
#AddressBox
    h2 Enter your address
    #search
        label(for="address-search-field") Enter your address to get started:
        .relative
            vue-autosuggest(
                class="autosuggest"
                ref="addressSearchField"
                :suggestions="addressSuggestions"
                :input-props="{ class:'autosuggest__input',  onInputChange: updateItems,  id: 'address-search-field', 'aria-label': 'Start typing your address and then use the arrow buttons to move through the list of matches.' }"
                :get-suggestion-value="getSuggestionValue"
                @selected="onSelected"
                :sectionConfigs="{ 'default': { limit: 30, } }"
            )
                template(slot-scope="{suggestion}")
                    .item {{ suggestion.label.text }}
</template>

<script>
function titleCase(str) {
    str = str || '';
    return str.toLowerCase().replace(/\b\S/g, (t) => t.toUpperCase());
}

import { VueAutosuggest } from 'vue-autosuggest';
import { getBoundaryForPoint } from './lookupBoundary';
import { EventBus } from '../EventBus';
import abbreviateStreet from './abbreviateStreet';

function chooseGeocoder() {
    if ((window.location + '').match(/vicmap/)) {
        return 'vicmap';
    }
    if ((window.location + '').match(/mapshare/)) {
        return 'mapshare';
    }
    return 'mapshare';
}
export default {
    name: 'AddressBox',
    components: {
        VueAutosuggest,
    },
    props: ['boundaryYear'],
    data: () => ({
        addressQuery: null,
        addressSuggestions: [],
        addressPoint: undefined,
        geocoder: chooseGeocoder(),
    }),
    created() {
        window.AddressBox = this;
    },

    methods: {
        async updateItemsMapshare(q) {
            const results = await window
                .fetch(
                    'https://corp-geo.mapshare.vic.gov.au/arcgis/rest/services/Geocoder/VMAddressEZIAdd/GeocodeServer/suggest?' +
                        new URLSearchParams({
                            text: q,
                            f: 'json',
                            // category: 'Address',
                        })
                )
                .then((response) => response.json());

            console.log(results);
            this.addressSuggestions = [
                {
                    data: results.suggestions.map((s) => ({
                        ...s,
                        text: titleCase(s.text),
                    })),
                },
            ];
        },
        async updateItemsVicmap(query) {
            try {
                const results = await window
                    .fetch(
                        'https://wovg-shared.gateway.prod.api.vic.gov.au/delwp/address/v1/suggestions?' +
                            new URLSearchParams({ query }),
                        {
                            headers: {
                                apikey: '81947559-cea9-4603-8ff4-c47a9698a250',
                                Accept: 'application/json, text/plain, */*',
                            },
                        }
                    )
                    .then((response) => response.json());

                const suggestions = results.suggestions.filter(
                    (s, i) =>
                        results.suggestions.findIndex(
                            (ss) => ss.label === s.label
                        ) === i
                );
                this.addressSuggestions = [
                    {
                        data: suggestions.map((s) => ({
                            text: [
                                s.street_number,
                                titleCase(s.street_name),
                                titleCase(abbreviateStreet(s.street_type)) +
                                    ',',
                                titleCase(s.suburb),
                                s.postcode,
                            ]
                                .join(' ')
                                .trim(),
                            coordinates: [s.longitude, s.latitude],
                        })),
                    },
                ];
            } catch (e) {
                EventBus.$emit('geocode-error', e);
            }
        },
        async updateItems(query) {
            if (query.length <= 2) {
                return;
            }
            EventBus.$emit('geocode-suggest');
            this[
                this.geocoder === 'vicmap'
                    ? 'updateItemsVicmap'
                    : 'updateItemsMapshare'
            ](query);
        },

        async onSelectedVicmap(query) {
            return query.item.coordinates.map(Number);
        },
        async onSelectedMapshare(query) {
            const locations = await window
                .fetch(
                    'https://corp-geo.mapshare.vic.gov.au/arcgis/rest/services/Geocoder/VMAddressEZIAdd/GeocodeServer/findAddressCandidates?' +
                        new URLSearchParams({
                            f: 'json',
                            SingleLine: query.item.text,
                            magicKey: query.item.magicKey,
                            spatialReference: { wkid: 4326 },
                        })
                )
                .then((response) => response.json());
            console.log(locations);
            const {
                candidates: [{ location }],
            } = locations;
            return [location.x, location.y];
        },
        async onSelected(query) {
            if (!query) {
                try {
                    // user pressed enter without selecting a value. let's use the first.
                    query = { item: this.addressSuggestions[0].data[0] };
                    this.$refs.addressSearchField.searchInput = query.item.text;
                } catch (e) {
                    return; // user presses enter before there are values
                }
            }

            EventBus.$emit('start-geocode');
            const coordinates = await this[
                this.geocoder === 'vicmap'
                    ? 'onSelectedVicmap'
                    : 'onSelectedMapshare'
            ](query);

            const geometry = {
                type: 'Point',
                coordinates,
            };

            this.addressQuery = query.item.text;
            const geocodeResult = {
                type: 'Feature',
                properties: {
                    label: query.item.text,
                },
                geometry,
            };
            EventBus.$emit('geocode-result', geocodeResult);

            this._lastLocation = geometry;
            const result = await getBoundaryForPoint(
                this.boundaryYear,
                coordinates
            );
            EventBus.$emit('boundary-results', result);
        },
        getSuggestionValue(suggestion) {
            // console.log(suggestion);
            return suggestion.item.text;
        },
        clearSuggestions() {
            this.$refs.addressSearchField.searchInput = '';
            this.clearGeocodeResult();
            this._lastLocation = null;
            window.app.SchoolInfo.zonedEntityCode = null;
            window.track('AddressSearch', 'clear');
            setTimeout(() => {
                this.addressSuggestions = [];
                this.addressQuery = '';
            }, 1);
            setTimeout(() => {
                this.$refs.addressSearchField.$el.children[0].focus();
            }, 10);
        },
    },
};
// import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
</script>

<style scoped>
.relative {
    position: relative;
}

label {
    /* color: #af272f; */
    display: block;
    margin-bottom: 0.5em;
}

input {
    margin: 0;
}

button.autocomplete-icon-close {
    /* height: 35px; */
    margin: 0;
    padding: 10px 10px;
    border-radius: 3px;
    border: 1px solid grey;
    top: 10px;
    right: 5px;
}
</style>

<style>
span.geocoder-icon-search {
    display: none;
}
</style>

<style>
.autocomplete-icon-close {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    background-repeat: no-repeat;
    /* background-image: url('../assets/download.svg'); */
    position: absolute;
    top: 56px;
    right: 22px;
    border: none;
}

.active {
    font-weight: bold;
}

.autosuggest__input {
    outline: none;
    appearance: none;

    color: unset !important;
    border: 1px solid grey;
    border-radius: 3px;
    padding: 10px;
    box-sizing: border-box;

    font-size: 16px;
    width: 100%;
    background-color: white;
    margin: 0;
    color: rgba(0, 0, 0, 0.5);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.autosuggest__input:focus {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.autosuggest__results {
    margin-top: 1px;
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    /* border-bottom: 1px solid grey; */
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 3px 3px;
}

.autosuggest__results ul {
    padding: 0;
    margin: 0;
    list-style: none;
}

.autosuggest__results .autosuggest__results_item {
    cursor: pointer;
    background-color: #fff;
    padding: 5px 10px;
    font-size: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.autosuggest__results .autosuggest__results_item:last-child {
    border-bottom: none;
}
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results
    .autosuggest__results_item-highlighted.autosuggest__results_item {
    background-color: #eee;
}
.autosuggest__results .autosuggest__results_item abbr {
    opacity: 0.8;
    font-size: 10px;
    display: block;
    font-family: sans-serif;
}

.campus-type {
    color: #555;
    font-size: 10px;
}

.campus-name {
    font-style: italic;
    font-size: 10px;
}

.v-autocomplete .v-autocomplete-input-group {
    border-radius: 3px;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.v-autocomplete .v-autocomplete-input-group .v-autocomplete-input {
    outline: none;
    appearance: none;

    width: 100%;
    color: unset !important;
    border: 1px solid grey;
    border-radius: 3px;
    padding: 10px;

    font-size: 16px;
    width: 100%;
    background-color: white;
    height: 40px;
    margin: 0;
    color: rgba(0, 0, 0, 0.5);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.v-autocomplete .v-autocomplete-list {
    margin-top: 1px;
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    /* border-bottom: 1px solid grey; */
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 3px 3px;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item {
    cursor: pointer;
    background-color: #fff;
    padding: 5px 10px;
    font-size: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:last-child {
    border-bottom: none;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:hover {
    background-color: #eee;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item abbr {
    opacity: 0.8;
    font-size: 10px;
    display: block;
    font-family: sans-serif;
}
</style>
